var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "7CFEA7B6-86C7-4085-8BB9-BE1541E40E29@1.5x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.270588 0 0 0 0 0.501961 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Assets-Import-3",
    transform: "translate(-909.000000, -546.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "loader",
    transform: "translate(866.000000, 525.000000)",
    filter: "url(#filter-1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(44.000000, 22.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 0,
    x2: 10,
    y2: 4,
    id: "Path",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 16,
    x2: 10,
    y2: 20,
    id: "Path",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.93,
    y1: 2.93,
    x2: 5.76,
    y2: 5.76,
    id: "Path",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.24,
    y1: 14.24,
    x2: 17.07,
    y2: 17.07,
    id: "Path",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 10,
    x2: 4,
    y2: 10,
    id: "Path",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 10,
    x2: 20,
    y2: 10,
    id: "Path",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.93,
    y1: 17.07,
    x2: 5.76,
    y2: 14.24,
    id: "Path",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.24,
    y1: 5.76,
    x2: 17.07,
    y2: 2.93,
    id: "Path",
    stroke: "#000000",
    strokeWidth: 2
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.e866e1d2.svg";
export { ForwardRef as ReactComponent };